import Quill from 'quill';
import { getNodeProperty } from 'libs/quill-utils';
import { inlineblotOrder } from './inline-blot-order';
const Inline = Quill.import('blots/inline');
const KEYWORD = 'keyword';
const getClasses = (value) => {
    const [type, bgColor, textColor] = value.split(' ');
    return `${KEYWORD}-${type} ${KEYWORD}-bgcolor-${bgColor} ${KEYWORD}-text-color-${textColor}`;
};
class KeywordBlot extends Inline {
    static create(value) {
        const node = super.create(value);
        if (inlineblotOrder.includes(KEYWORD)) {
            const keywordBgColor = value.split(' ')[1];
            node.className = getClasses(value);
            node.style.backgroundColor = keywordBgColor === 'default' ? 'var(--keyword-bgcolor)' : keywordBgColor;
        }
        else {
            throw new Error('Blot is not listed in inline blot order'); // if the format name is missing in blot order, it causes bugs in quill, see https://github.com/quilljs/quill/issues/2312
        }
        return node;
    }
    static formats(domNode) {
        return KeywordBlot.valueFromDomNode(domNode);
    }
    static valueFromDomNode(domNode) {
        const typePrefix = `${KEYWORD}-`;
        const bgColorPrefix = `${KEYWORD}-bgcolor-`;
        const textColorPrefix = `${KEYWORD}-text-color-`;
        const type = getNodeProperty(domNode, typePrefix);
        const bgColor = getNodeProperty(domNode, bgColorPrefix);
        const textColor = getNodeProperty(domNode, textColorPrefix);
        if (type === null) {
            throw Error('warning type is missing');
        }
        if (bgColor === null || textColor === null) {
            return `${type} var(--keyword-bgcolor) black`;
        }
        return `${type} ${bgColor} ${textColor}`;
    }
    format(name, value) {
        if (name === KEYWORD) {
            if (value) {
                this.domNode.className = getClasses(value);
            }
            else {
                this.unwrap();
            }
        }
        else {
            super.format(name, value);
        }
    }
    formats() {
        const formats = super.formats();
        formats.keyword = KeywordBlot.formats(this.domNode);
        return formats;
    }
    attach() {
        if (this.parent != null) {
            this.scroll = this.parent.scroll;
        }
    }
}
KeywordBlot.blotName = KEYWORD;
export default KeywordBlot;
KeywordBlot.blotName = KEYWORD;
// setting a custom tag name prevents some really weird bugs in quill.
KeywordBlot.tagName = KEYWORD;
